import script from "./index.vue?vue&type=script&setup=true&lang=ts&generic=TR%20extends%20BaseTableRow%2C%20HD%20extends%20BaseHeader"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&generic=TR%20extends%20BaseTableRow%2C%20HD%20extends%20BaseHeader"

import "./index.vue?vue&type=style&index=0&id=60db2fc6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60db2fc6"]])

export default __exports__